const HemoActions = {
    SEARCH: "hemo/search",
    SEARCH_RESULT: "hemo/search-result",
    SEARCH_ERROR: "hemo/search-error",
};

export default HemoActions;



// WEBPACK FOOTER //
// ./app/data/HemoActions.js